import React, { RefObject } from 'react';
import { BsPlay, BsPause } from "react-icons/bs";
import { Playlist } from '../types';
import PlaylistSelector from './PlaylistSelector';

interface PlayerControlsProps {
  currentPlaylist: Playlist | null;
  isPaused: boolean;
  currentSong: boolean;
  isPlaylistMenuOpen: boolean;
  onPlaylistButtonClick: () => void;
  onTogglePlayPause: () => void;
  onPlaylistSelect: (playlist: Playlist) => void;
  playlists: Playlist[];
  playlistButtonRef: RefObject<HTMLDivElement>;
  playlistMenuRef: RefObject<HTMLDivElement>;
  isWalkthroughMode?: boolean; // Flag to bypass subscription checks during walkthrough
}

const PlayerControls: React.FC<PlayerControlsProps> = ({
  currentPlaylist,
  isPaused,
  currentSong,
  isPlaylistMenuOpen,
  onPlaylistButtonClick,
  onTogglePlayPause,
  onPlaylistSelect,
  playlists,
  playlistButtonRef,
  playlistMenuRef,
  isWalkthroughMode = false
}) => {
  return (
    <div className="player-controls">
      <div 
        className="now-playing" 
        onClick={onPlaylistButtonClick}
        ref={playlistButtonRef}
      >
        <div className="now-playing-content">
          <span className="playlist-name">{currentPlaylist?.name || 'No Playlist'}</span>
        </div>
        <PlaylistSelector
          isPlaylistMenuOpen={isPlaylistMenuOpen}
          playlists={playlists}
          currentPlaylist={currentPlaylist}
          onPlaylistSelect={onPlaylistSelect}
          menuRef={playlistMenuRef}
          isWalkthroughMode={isWalkthroughMode}
        />
      </div>
      <button className="pause-play-button" onClick={onTogglePlayPause} disabled={!currentSong}>
        {isPaused ? <BsPlay /> : <BsPause />}
      </button>
    </div>
  );
};

export default PlayerControls; 